<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Datatable from "@/router/layouts/table-datatable.vue";
import Pagination from "@/router/layouts/table-pagination.vue";
import axios from "axios";
import Swal from "sweetalert2";
import moment from "moment";
import _ from "lodash";
import ReportHasilSurvei from "./report-hasil/report-hasil-survei.vue";

export default {
  page: {
    title: "Report Survei",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Datatable,
    Pagination,
    ReportHasilSurvei,
  },
  data() {
    let sortOrders = []; // select sortOrder
    let columns = [
      { label: "No", name: "no", width: "auto" },
      { label: "Pelaksanaan", name: "pelaksanaan", width: "auto" },
      { label: "Kode Tes", name: "kode_tes", width: "auto" },
      { label: "Keterangan", name: "keterangan", width: "auto" },
      { label: "Batch", name: "nama_batch", width: "auto" },
      { label: "Tanggal Batch", name: "tanggal_batch", width: "400px" },
      { label: "NIP", name: "nip", width: "auto" },
      { label: "Nama", name: "nama", width: "auto" },
      { label: "Jabatan", name: "jabatan_asesmen", width: "auto" },
      { label: "Judul Kompetensi", name: "nama_kompetensi", width: "auto" },
      { label: "Level Proficiency", name: "nama_level", width: "auto" },
    ];

    // cek sorting
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });

    return {
      title: "Report Survei Peserta",
      isWrite: localStorage.getItem("isWrite"),
      isRead: localStorage.getItem("isRead"),
      showModalAdd: false,
      showModalEdit: false,
      selected_id: "ss",
      namePathUrl: this.$route.name,
      sessionRoleId: localStorage.session_role_active_id,
      loadingTable: true,
      table_data: [],
      columns: columns,
      sortKey: "id_role", // sort key awal
      sortOrders: sortOrders,
      currentTablePage: "",
      listPertanyaan: [], // akan diisi kemudian

      // parsing data ke table data
      tableData: {
        draw: 0,
        per_page: 10,
        search: "",
        column: 0,
        dir: "asc",
        kompetensi: "",
        pelaksanaan: "",
        nama: "",
        nip: "",
        level: "",
      },

      selected_id_jadwal: "",
      selected_batch: "",
      selected_jabatan: "",
      filterKompetensi: null,
      filterLevel: null,

      // config untuk paginasi
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: "",
      },

      option_jadwal: [],
      option_jabatan: [],
      option_batch: [],
      option_pelaksanaan: [],
      option_kompetensi: [],
      option_level: [],
    };
  },
  async mounted() {
    let self = this;
    // self.cekAksesMenu();
    await self.getPertanyaanSurvei();
    self.getDataTable();
    self.getFilterPelaksanaan();
    self.getFilterKompetensi();
    self.getFilterLevel();

    self.filterKompetensi = _.debounce(this.searchKompetensi.bind(this), 500);
    self.filterData = _.debounce(this.getDataTable.bind(this), 500);
    self.filterLevel = _.debounce(this.getDataTable.bind(this), 500);
  },
  methods: {
    async getPertanyaanSurvei() {
      let self = this;
      var config = {
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "referensi/pertanyaan-survei",
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token_peserta,
        },
      };

      axios(config)
        .then((response) => {
          self.listPertanyaan = response.data.data.data;
          self.addDynamicColumns();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addDynamicColumns() {
      this.listPertanyaan.forEach((item, index) => {
        const columnName = `pertanyaan_${index + 1}`;
        this.columns.push({
          label: `Pertanyaan ${index + 1}`,
          name: "-",
          width: "auto",
        });

        // tambahkan juga ke sortOrders agar tetap sinkron
        this.sortOrders[columnName] = -1;
      });
      this.columns.push({
        label: "Total Skor",
        name: "total_skor",
        width: "auto",
      });
      this.columns.push({
        label: "Rata Rata Skor",
        name: "rata_rata_skor",
        width: "auto",
      });
      this.columns.push({
        label: "Indeks Kepuasan",
        name: "indeks_kepuasan",
        width: "auto",
      });
    },
    searchPelaksanaan(loading, search) {
      loading(true);
      this.getFilterPelaksanaan(search, loading);
    },
    async getFilterPelaksanaan(search, loading) {
      const data = await axios({
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "referensi/jadwal-pelaksanaan/all",
        params: {
          search: search,
          limit: 50,
        },
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
        },
      })
        .then((response) => response.data.data)
        .catch((err) => {
          console.log("err get jadwal pelaksanaan", err);
          return false;
        });

      if (data) this.option_pelaksanaan = data;
      if (loading) loading(false);
    },
    async searchKompetensi(search, loading) {
      if (search.length) {
        loading(true);
        this.getFilterKompetensi(search, loading);
      }
    },
    async getFilterKompetensi(search = "", loading) {
      await axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/kompetensi/all",
          {
            params: {
              search: search,
              limit: 10,
            },
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
            },
          }
        )
        .then((response) => {
          this.option_kompetensi = response.data.data;
          if (loading) loading(false);
        });
    },
    async getFilterLevel(search = "", loading) {
      await axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "referensi/level-kompetensi/all",
          {
            params: {
              search: search,
              limit: 10,
            },
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
            },
          }
        )
        .then((response) => {
          this.option_level = response.data.data.data;
          if (loading) loading(false);
        });
    },
    fullDateTimeFormat(datetime) {
      return moment(datetime).format("YYYY-MM-DD HH:mm");
    },
    getDataTable(resetPage = true) {
      this.tableData.page = resetPage ? 1 : this.tableData.page;
      let self = this;
      self.loadingTable = true;
      self.tableData.draw++;

      var config = {
        method: "get",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "report-survei",
        params: self.tableData,
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };

      axios(config)
        .then((response) => {
          let response_data = response.data;
          let response_data_fix = response_data.data.data;
          if (response_data.meta.code == 200) {
            console.log(response_data_fix);
            self.table_data = response_data_fix.data;
            console.log("table data", self.table_data);
            self.configPagination(response_data_fix);
            self.currentTablePage = response_data_fix.current_page;
            self.loadingTable = false;
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response_data_fix.data.message,
            });
          }
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
      this.pagination.links = data.links;
    },
    sortBy(key) {
      let self = this;
      self.sortKey = key;
      self.sortOrders[key] = self.sortOrders[key] * -1;
      self.tableData.column = self.getIndex(self.columns, "name", key);
      self.tableData.dir = self.sortOrders[key] === 1 ? "asc" : "desc";
      self.getDataTable();
    },
    getIndex(array, key, value) {
      return array.findIndex((i) => i[key] == value);
    },
    toPage(url) {
      let link = new URLSearchParams(url.split("?")[1] || "");
      console.log({ url, link });
      this.tableData.page = link.get("page");
      // this.tableFilter.per_page = link.get('per_page');
      this.getDataTable(false);
    },
    onChangeJadwal() {
      this.tableData.idbatch = null;
      this.tableData.idjadwal = this.selected_id_jadwal?.idjadwal;
      this.searchBatch(true, "");
    },
    onChangeJabatan() {
      this.tableData.jabatan = this.selected_jabatan?.nama_jabatan;
    },
    checkPertanyaanMatch(idPertanyaan, pertanyaanSkorJson) {
      try {
        const arr = JSON.parse(pertanyaanSkorJson || "[]");
        return arr.some((item) => item.idpertanyaan_survei === idPertanyaan);
      } catch (e) {
        console.error("Invalid JSON in pertanyaan_skor:", pertanyaanSkorJson);
        return false;
      }
    },

    getSkor(idPertanyaan, pertanyaanSkorJson) {
      try {
        const arr = JSON.parse(pertanyaanSkorJson || "[]");
        const item = arr.find((i) => i.idpertanyaan_survei === idPertanyaan);
        return item ? item.skor : "-";
      } catch (e) {
        return "-";
      }
    },

    exportData() {
      let params = new URLSearchParams(this.tableData).toString();
      window.open(
        process.env.VUE_APP_BACKEND_URL_VERSION +
          "export-excel/report-survei?" +
          params
      );
    },
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <b-card no-body>
          <b-tabs pulls card>
            <b-tab title="Report Survei">
              <div class="row">
                <div class="d-flex justify-content-between">
                  <div class="card-title">Report Survei</div>
                  <div class="d-flex gap-2">
                    <button
                      class="btn btn-sm btn-primary"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseFilterReportSurvei"
                      aria-expanded="false"
                      aria-controls="collapseFilterReportSurvei"
                    >
                      <i class="fa fa-filter me-1"></i> Filter Data
                    </button>
                    <button
                      class="btn btn-success btn-sm"
                      @click="exportData()"
                    >
                      <i class="fa fa-file-excel"></i> Export Excel
                    </button>
                  </div>
                </div>
                <div class="col-md-12">
                  <hr />
                  <div class="row collapse" id="collapseFilterReportSurvei">
                    <div class="form-group col-md-4 mb-2">
                      <label for="statusTable">Pelaksanaan</label>
                      <v-select
                        :options="option_pelaksanaan"
                        :reduce="(pelaksanaan) => pelaksanaan.pelaksanaan"
                        v-model="tableData.pelaksanaan"
                        label="pelaksanaan"
                        placeholder="Pilih Pelaksanaan"
                        @search="searchPelaksanaan"
                        v-on:update:modelValue="getDataTable()"
                      >
                      </v-select>
                    </div>
                    <div class="form-group col-md-4 mb-2">
                      <label for="statusTable">NIP</label>
                      <input
                        type="nip"
                        class="form-control"
                        id="tanggal_selesai"
                        placeholder="Filter NIP"
                        v-model="tableData.nip"
                        @input="filterData()"
                      />
                    </div>
                    <div class="form-group col-md-4 mb-2">
                      <label for="statusTable">Nama</label>
                      <input
                        type="text"
                        class="form-control"
                        id="tanggal_selesai"
                        placeholder="Filter Nama"
                        v-model="tableData.nama"
                        @input="filterData()"
                      />
                    </div>

                    <div class="col-md-4 mb-2">
                      <label for="filterKompetensi">Kompetensi</label>
                      <v-select
                        id="parent_menu"
                        class="style-chooser"
                        :options="option_kompetensi"
                        :reduce="(kompetensi) => kompetensi.nama_kompetensi"
                        label="nama_kompetensi"
                        v-model="tableData.kompetensi"
                        placeholder="Filter Kompetensi"
                        @search="filterKompetensi"
                        @update:modelValue="getDataTable()"
                      >
                      </v-select>
                    </div>

                    <div class="col-md-4">
                      <label for="FilterUnit">Level</label>
                      <v-select
                        id="parent_menu"
                        class="style-chooser"
                        :options="option_level"
                        :reduce="(level) => level.nama_level"
                        label="nama_level"
                        v-model="tableData.level"
                        placeholder="Filter Level"
                        @update:modelValue="getDataTable()"
                      >
                      </v-select>
                    </div>
                    <hr />
                  </div>
                </div>
                <div class="col-md-12 mb-2">
                  <div class="row">
                    <div class="col-md-6">
                      <table>
                        <tr>
                          <td>Show</td>
                          <td>
                            <select
                              class="form-control form-control-sm"
                              id="showpaginatetable"
                              style="width: 100%"
                              v-model="tableData.per_page"
                              @change="
                                tableData.page = 1;
                                getDataTable();
                              "
                            >
                              <option value="10" selected>10</option>
                              <option value="50">50</option>
                              <option value="100">100</option>
                              <option value="200">200</option>
                              <option value="500">500</option>
                            </select>
                          </td>
                          <td>Entries</td>
                        </tr>
                      </table>
                    </div>
                    <!-- <div class="col-md-5">&nbsp;</div> -->
                    <!-- <div class="col-md-3">
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      id="searchTable"
                      placeholder="Cari Data ..."
                      v-model="tableData.search"
                      @input="getDataTable()"
                    />
                  </div> -->
                  </div>
                </div>
              </div>
              <div class="table-responsive mb-0">
                <datatable
                  :columns="columns"
                  :sortKey="sortKey"
                  :sortOrders="sortOrders"
                  @sort="sortBy"
                  :class="'table align-middle table-nowrap'"
                >
                  <tbody>
                    <tr v-if="loadingTable">
                      <td colspan="99" class="text-center">
                        <i class="fas fa-spinner fa-spin"></i> Loading...
                      </td>
                    </tr>
                    <tr v-else-if="table_data == ''" class="text-center">
                      <td class="text-center" colspan="99">
                        Data Tidak Tersedia
                      </td>
                    </tr>
                    <tr
                      v-else
                      v-for="(row_data, key_data) in table_data"
                      :key="key_data"
                    >
                      <td class="text-center">
                        <div v-if="key_data + 1 == 10">
                          {{ currentTablePage }}0.
                        </div>
                        <div v-else>
                          {{
                            currentTablePage - 1 != 0
                              ? currentTablePage - 1
                              : ""
                          }}{{ key_data + 1 }}.
                        </div>
                      </td>
                      <td>
                        {{ row_data.pelaksanaan }}
                      </td>
                      <td>
                        {{ row_data.kode_tes }}
                      </td>
                      <td>
                        {{ row_data.keterangan }}
                      </td>
                      <td>
                        {{ row_data.nama_batch }}
                      </td>
                      <td>
                        {{ fullDateTimeFormat(row_data.waktu_mulai) }} -
                        {{ fullDateTimeFormat(row_data.waktu_selesai) }}
                      </td>
                      <td>
                        {{ row_data.nip }}
                      </td>
                      <td>
                        {{ row_data.nama }}
                      </td>
                      <td>
                        {{ row_data.jabatan_asesmen }}
                      </td>
                      <td>
                        {{ row_data.nama_kompetensi }}
                      </td>
                      <td>
                        {{ row_data.nama_level }}
                      </td>
                      <td
                        class="text-center"
                        v-for="(value, key) in listPertanyaan"
                        :key="key"
                      >
                        <span
                          v-if="
                            checkPertanyaanMatch(
                              value.idpertanyaan_survei,
                              row_data.pertanyaan_skor
                            )
                          "
                        >
                          {{
                            getSkor(
                              value.idpertanyaan_survei,
                              row_data.pertanyaan_skor
                            )
                          }}
                        </span>
                        <span v-else> - </span>
                      </td>
                      <td class="text-center">
                        {{ row_data.total_skor }}
                      </td>
                      <td class="text-center">
                        {{ row_data.rerata_skor }}
                      </td>
                      <td class="text-center">
                        {{ row_data.indeks_kepuasan }}
                      </td>
                    </tr>
                  </tbody>
                </datatable>
              </div>
              <pagination
                :pagination="pagination"
                @to-page="toPage"
              ></pagination>
            </b-tab>
            <b-tab title="Survei Peserta">
              <ReportHasilSurvei />
            </b-tab>
          </b-tabs>
        </b-card>
      </div>
    </div>
  </Layout>
</template>
